module.exports = __webpack_public_path__ + "img/right-align.a8217713.svg";